import React, { useEffect, useState } from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import blog1 from "../../images/blog1.jpg";
import blog2 from "../../images/blog2.png";
import blog3 from "../../images/blog3.jpg";
import blog4 from "../../images/blog4.jpg";
import shape14 from "../../images/shape-14.png";
import shape12 from "../../images/shape-12.png";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
const Blog1 = () => {
  const [blog, setBlog] = useState([]);
  let { id } = useParams()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  async function getBlogs() {
    let { data } = await axios.get(
      `https://maps-medics-be.onrender.com/`+id
    );
    setBlog(data);

    console.log(data);
  }
  useEffect(() => {

    getBlogs();
  }, []);
  
  return (
    <>
    {/* <Navbar/> */}

    <div class="section pageBanner">
      <div
        style={{
          backgroundColor: "rgba(0,0,0,0.4)",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          class="container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div class="page-banner-content">
            {/* <ul class="breadcrumb">
              <li><a>Home</a></li>
              <li class="active">Blog</li>
          </ul> */}
            {/* <h2 class="title" style={{color:'#fff'}}> With numbers: What is the <br /> average salary and lifestyle of a physician in the USA? <span>January 10, 2023</span></h2> */}
          </div>
        </div>
      </div>
    </div>
    <div className="container ">
      <div className="row">
        <h2 class="title" style={{ color: "#000", paddingTop: "3%" }}>
          {" "}
          With numbers: What is the average salary and lifestyle of a
          physician in the USA? <span>January 10, 2023</span>
        </h2>
      </div>
      <div className="row p-4">
        <div className="col-md-6">
          <img src={blog1} style={{ borderRadius: "10px" }} alt="" />
        </div>
        <div className="col-md-6">
          <h5>
            <i
              class="fa-solid fa-check-double"
              style={{ color: "#ffc600" }}
            ></i>
            As a physician in the United States, you can expect to earn a
            generous salary and enjoy a comfortable lifestyle. But just how
            much can you expect to make, and what does that translate to in
            terms of your day-to-day life? In this post, we’ll break down the
            average salary and lifestyle of a physician in the USA using the
            most up-to-date data available.
          </h5>
          <h5>
            <i
              class="fa-solid fa-check-double"
              style={{ color: "#ffc600" }}
            ></i>
            According to the Medical Group Management Association’s (MGMA)
            Physician Compensation and Production Survey, the average salary
            for a physician in the USA is $299,000 per year. This varies
            depending on your specialty, with surgeons earning the most at an
            average of $409,665 per year, followed by orthopedists at
            $397,676, and cardiologists at $376,000. On the lower end of the
            scale, pediatricians and family medicine physicians earn an
            average of $220,380 and $225,390, respectively.
          </h5>
        </div>
      </div>
      <div className="row p-3">
        <div className="col-md-6">
          <h5>
            <i
              class="fa-solid fa-check-double"
              style={{ color: "#ffc600" }}
            ></i>
            It’s important to note that while you’re in residency training,
            your salary will likely be much lower than the average we
            discussed above. The amount you earn during this time will depend
            on the program you’re in, but it’s common for residents to make
            around $50,000 to $60,000 per year. This can be a significant pay
            cut from what you may have been earning previously, but it’s
            important to remember that your salary will increase significantly
            once you complete your training and become a fully-fledged
            physician. It’s also worth considering that your cost of living
            may be lower while you’re in training, as many residency programs
            offer housing and other benefits.
          </h5>
        </div>
        <div className="col-md-6">
          <h5>
            <i
              class="fa-solid fa-check-double"
              style={{ color: "#ffc600" }}
            ></i>
            But what does a salary like this translate to in terms of your
            lifestyle? Well, it all depends on your financial situation and
            spending habits. However, with a physician’s salary, you can
            expect to be able to afford a comfortable home, a reliable
            vehicle, and a decent standard of living. You may even be able to
            save up for retirement, pay off any outstanding debts, or invest
            in your future.
          </h5>
          <h5>
            <i
              class="fa-solid fa-check-double"
              style={{ color: "#ffc600" }}
            ></i>
            Overall, the average salary and lifestyle of a physician in the
            USA are quite comfortable, but it’s important to keep in mind that
            every individual’s financial situation is unique. It’s always a
            good idea to create a budget and plan for your future, no matter
            what field you’re in.
          </h5>
        </div>
      </div>
      <h2 class="title" style={{ color: "#000", paddingTop: "3%" }}>
            {" "}
          {blog.title} <span> {blog.date}</span>
          </h2>
        </div>
        <div className="row p-4">
          <div className="col-md-6">
            <img src={blog.image} style={{ borderRadius: "10px" }} alt="" />
          </div>
          <div className="col-md-6">
            {/* <h5>
              <i
                class="fa-solid fa-check-double"
                style={{ color: "#ffc600" }}
              ></i>
          {blog.smail_text}
            </h5> */}
            </div>
                </div>
    <div class="section section-padding">
          <div class="container">

              <div class="contact-wrapper">
                  <div class="row align-items-center">
                      <div class="col-lg-12">

                          <div class="contact-info">

                              <img class="shape animation-round" src={shape12} alt="Shape"/>
<h2>Leave A Reply</h2>
                         
                              <div class="single-contact-info">
                        
                                  <div class="info-content">
                                      <h6 class="title">Comment *</h6>
                                  
<textarea type="text" className='form-control' placeholder='Comment'/>
                                  </div>
                              </div>
                             
                         
                              <div class="single-contact-info">
                                 
                                  <div class="info-content">
                                      <h6 class="title">Name *</h6>
                               
<input type="text" className='form-control' placeholder='Name' />
                                  </div>
                              </div>
                             
                         
                              <div class="single-contact-info">
                                
                                  <div class="info-content">
                                      <h6 class="title">Email *</h6>
                                      <input type="text" className='form-control' placeholder='Email' />
                                  </div>
                              </div>
                             
                              <div class="single-contact-info">
                                
                                <div class="info-content">
                                    <h6 class="title">Website</h6>
                                    <input type="text" className='form-control' placeholder='Website' />
                                </div>
                            </div>
                           <button class="btn btn-primary " style={{backgroundColor:'#FFC600', border:'#FFC600', borderRadius:'20px', float:'right'}}>Post Comment</button>
                          </div>
                         

                      </div>
                    
                  </div>
              </div>

          </div>
      </div>
      {/* <Footer/> */}
    </>
    );
}

export default Blog1;
